module.exports = __webpack_public_path__ + "img/icon_card.e26608a.svg";